import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles/theme.css";

export const teamNewsItemStyles = style({
  display: "flex",
  alignItems: "center",
  gap: vars.space.m,
});

export const newsItemLinkStyles = style({
  maxHeight: "calc(2 * 1.4em)",
  overflow: "hidden",
  textDecoration: "none",
  color: vars.colors.onSurface,
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.heading.xs,
  fontWeight: 400,
});
